import React from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { Sticky } from 'react-sticky';
import SidebarItem from './SidebarItem';

const BreadcrumbsArrow = () => <i className="arrow-icon icon-budicon-461" />;

const Breadcrumbs = ({ crumbs }) => (
  <span>
    {crumbs.map((crumb, index) => (
      <span key={`${crumb.title} ${crumb.url}`}>
        {crumb.title}
        {index < crumbs.length - 1 && <BreadcrumbsArrow />}
      </span>
    ))}
  </span>
);

Breadcrumbs.propTypes = {
  crumbs: PropTypes.array.isRequired
};

// Fix Remove IOS Rubber effect
// https://github.com/luster-io/prevent-overscroll/blob/master/index.js
const removeIOSRubberEffect = (element) => {
  /* eslint-disable no-param-reassign */
  element.addEventListener('touchmove', () => {
    const top = element.scrollTop;
    const totalScroll = element.scrollHeight;
    const currentScroll = top + element.offsetHeight;

    if (top === 0) {
      element.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      element.scrollTop = top - 1;
    }
  });
  /* eslint-enable no-param-reassign */
};

class Sidebar extends React.Component {
  state = {
    openDropdown: false
  };

  componentDidMount() {
    removeIOSRubberEffect(this.sidebarScrollable);
    this.scrollSideBarIntoView();
  }

  shouldComponentUpdate(nextProps, nextState) {
    // There are situations when the pages are transitioning when the section or the url
    // may not yet be known. To provide a smooth transition we dont want to rerender this
    // component until the new page's values are set.
    if (!nextProps.section || !nextProps.url) {
      return false;
    }
    return PureRenderMixin.shouldComponentUpdate(this, nextProps, nextState);
  }

  componentDidUpdate() {
    this.scrollSideBarIntoView();
  }

  scrollSideBarIntoView() {
    const active = $('.sidebar-item a.active')[0];
    const list = $('ul.sidebar-item-list')[0];
    if (active && list) list.scrollTop = active.offsetTop;
  }

  handleToggle = () => {
    $('html, body').toggleClass('overflow-hidden', !this.state.openDropdown);

    // Set scrollable menu area acording to scroll offset
    const sidebarTopOffset = this.sidebarContent.getBoundingClientRect().top;
    const sidebarHeight = `calc(100vh - ${sidebarTopOffset.toString()}px)`;

    if (!this.state.openDropdown) {
      this.sidebarContent.style.height = sidebarHeight;
    } else {
      this.sidebarContent.style.height = '';
    }

    this.setState({
      openDropdown: !this.state.openDropdown
    });
  };

  render() {
    const { items, maxDepth, section, breadcrumbs, isQuickstart } = this.props;
    const { openDropdown } = this.state;

    return (
      <Sticky>
        {({ isSticky, style }) => (
          <div style={style} className={isSticky ? 'sticky' : ''}>
            <div className={`sidebar ${isQuickstart ? 'is-quickstart' : 'is-article'}`}>
              <div className="section-title">{section}</div>
              <ul
                ref={(e) => {
                  this.sidebarContent = e;
                }}
                className={`
                  sidebar-item-list
                  sidebar-item-list-depth0
                  ${openDropdown ? 'is-dropdown-open' : ''}
                `}
              >
                <div
                  className="mobile-dropdown-trigger"
                  onClick={this.handleToggle}
                  role="button"
                >
                  <h5 className="mobile-dropdown-title">
                    <Breadcrumbs crumbs={breadcrumbs} />
                  </h5>
                  <i className={`mobile-dropdown-icon icon-budicon-${openDropdown ? '462' : '460'}`} />
                </div>
                <div
                  className="mobile-dropdown-content scrollable"
                  ref={(e) => {
                    this.sidebarScrollable = e;
                  }}
                >
                  {items.map(item => (
                    <SidebarItem
                      {...item}
                      article={item}
                      key={item.url}
                      currentDepth={0}
                      maxDepth={maxDepth}
                      handleOnClick={this.handleToggle}
                    />
                  ))}
                </div>
              </ul>
            </div>
          </div>
        )}
      </Sticky>
    );
  }
}

Sidebar.propTypes = {
  // Note: section and url required because of state change, see shouldComponentUpdate
  items: PropTypes.array.isRequired,
  section: PropTypes.string,
  maxDepth: PropTypes.number,
  url: PropTypes.string,
  breadcrumbs: PropTypes.array.isRequired,
  isQuickstart: PropTypes.bool
};

Sidebar.defaultProps = {
  maxDepth: 2
};

export default Sidebar;
